var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13.8497H16.15C16.5228 13.8458 16.8928 13.9158 17.2384 14.0557C17.584 14.1957 17.8984 14.4027 18.1635 14.665C18.4285 14.9273 18.6389 15.2395 18.7825 15.5836C18.9261 15.9277 19 16.2969 19 16.6697V17.0997C19 17.8476 18.7029 18.5649 18.174 19.0938C17.6452 19.6226 16.9279 19.9197 16.18 19.9197H13V9.21973H15.66C15.9379 9.21972 16.2131 9.27463 16.4698 9.38129C16.7264 9.48795 16.9595 9.64427 17.1555 9.84126C17.3516 10.0383 17.5068 10.272 17.6123 10.5292C17.7177 10.7863 17.7713 11.0618 17.77 11.3397V11.6697C17.7713 11.9472 17.7177 12.2222 17.6121 12.4788C17.5065 12.7353 17.3511 12.9685 17.1549 13.1647C16.9588 13.3609 16.7256 13.5162 16.469 13.6218C16.2124 13.7274 15.9375 13.7811 15.66 13.7797H13",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33008 19.9L5.71008 9.29004L9.55008 19.9",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90991 16.0498H7.58991",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.16 14.0703L25.94 16.2903L23.72 14.0703",
    stroke: "#4E575E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiple);
export default __webpack_public_path__ + "static/media/Multiple.8241ffbb149270190f431f7a6b8212ef.svg";
export { ForwardRef as ReactComponent };